export const gradientTextStyle = {
    background: 'linear-gradient(90deg, rgba(255, 228, 86, 1), rgba(67, 255, 153, 1))',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    textFillColor: 'transparent',
  };